module.exports = __webpack_public_path__ + "img/desk1.3b41d08f.png";